<template>
	<div id="users-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingUsers">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header, index)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
							<SortUpDown
								v-if="header.field !== 'actions'"
								:isActive="header.isActive"
								:alt="'Ordenar por ' + header.label"
							/>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="row.id"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>{{ row.firstName }} {{ row.lastName }}</td>
					<td>
						{{ row.email }}
					</td>
					<td>
						{{ getCompanyName(row) }}
					</td>
					<td>
						{{ row.userRoles != null ? row.userRoles.roleName : ' - ' }}
					</td>
					<td>
						{{ row.userStatus != null ? row.userStatus.name : ' - ' }}
					</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingUsers">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingUsers"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import SortUpDown from '@/components/shared/Icons/SortUpDown.vue';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';

export default {
	name: 'Table',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		SortUpDown,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({
		tableHeader: [
			{
				field: 'firstName',
				label: 'Nome',
				isActive: null,
			},
			{
				field: 'email',
				label: 'E-mail',
				isActive: null,
			},
			{
				field: 'investor',
				label: 'Empresa',
				isActive: null,
			},
			{
				field: 'userRoles',
				label: 'Tipo de Usuário',
				isActive: null,
			},
			{
				field: 'enable',
				label: 'Status',
				isActive: null,
			},
			{
				field: 'actions',
				label: 'Ações',
				isActive: null,
			},
		],
	}),
	mounted() {},
	methods: {
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param, index) {
			if (param.field == 'actions') return;
			this.setArrowIcon(index);
			this.$emit('orderByHeader', param.field);
		},
		setArrowIcon(index) {
			if (this.tableHeader[index].isActive === null) {
				this.tableHeader[index].isActive = false;
			} else {
				this.tableHeader[index].isActive = !this.tableHeader[index].isActive;
			}
			this.tableHeader = this.tableHeader.map((el, idx) => {
				if (idx !== index) {
					el.isActive = null;
				}
				return el;
			});
		},
		editRow(row) {
			this.$router.push({
				path: '/dashboard/user/detail',
				query: { id: row.id },
			});
		},
		getCompanyName(row) {
			if(!row.userRoles) return;

			switch (row.userRoles.roleName) {
				case 'Originador':
					return row.originator && row.originator.name ? row.originator.name : ' - ';
				case 'Investidor':
				case 'Administrador':
					return row.investor && row.investor.name ? row.investor.name : ' - ';
				case 'Estruturador':
					return row.structurer && row.structurer.name ? row.structurer.name : ' - ';
				default:
					return ' - ';
			}
		},
	},
	computed: {
		...mapGetters('userManagement', ['userList', 'isLoadingUsers']),
		tableRows() {
			const rows = this.userList.users != undefined ? this.userList.users : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination = this.userList.totalPages != undefined ? this.userList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Table.scss';
</style>
